<template>
  <v-expansion-panels>
    <v-expansion-panel
      v-for="(value, key) in bookmarkList" :key="key"
    >
      <!-- 条件分岐でh3だったらチェックボックス、nameだったら同じコンポーネントを呼ぶ -->
      <template v-if="value.name">
        <ATagCheckBox :name="value.name" :url="value.url" :tagId="key" />
      </template>
      <template v-if="value.h3">
        <DirCheckBox :h3="value.h3" :aList="value.a" :dir="value.dir" :tagId="key" />
      </template>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import ATagCheckBox from '../molecules/bookmarks/ATagCheckBox.vue'
import DirCheckBox from '../molecules/bookmarks/DirCheckBox.vue'
export default {
    data () {
      return {
        selected: []
      }
    },
    components: {
      ATagCheckBox,
      DirCheckBox
    },
    props: [
      'bookmarkList'
    ]
  }
</script>